import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CheckDiffText from './CheckDiffText';

class Other extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { port, newPort } = this.props;

        return (
            <Fragment>
                <div className="main__title">
                    other
                </div>

                <div className="other">
                    <CheckDiffText
                        oldValue={port.additionalDescription}
                        newValue={newPort.additionalDescription}
                    />
                </div>
            </Fragment>
        );
    }
}

Other.propTypes = {
    port: PropTypes.object,
};

Other.defaultProps = {
    port: '',
};

export default connect(
    (state, { port, newPort }) => {
        return {
            port,
            newPort,
        };
    },
    dispatch => bindActionCreators({
    }, dispatch),
)(Other);


// WEBPACK FOOTER //
// ./app/components/Regions/PortApprove/Other.jsx